import * as React from "react";
import styled from "styled-components";

interface Props {
  onClickShowInvoices: () => void;
  disabled?: boolean;
}

const Wrapper = styled.div`
  input {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const ActionButtons = ({ onClickShowInvoices, disabled }: Props) => {
  return (
    <Wrapper>
      <input
        type="button"
        value="Visa fakturor"
        className="button primary"
        onClick={() => onClickShowInvoices()}
        disabled={disabled}
      />
    </Wrapper>
  );
};

export default ActionButtons;
